import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 12, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, title, lead, align = "left", children }) => (
  <div className={`mb-10 lg:mb-14 max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <div className="eyebrow mb-3">
          <span className="inline-flex items-center gap-0.5" aria-hidden="true">
            <span className="inline-block h-1.5 w-4 rounded-full bg-[hsl(var(--orange))]" />
            <span className="inline-block h-1.5 w-3 rounded-full bg-foreground/30" />
            <span className="inline-block h-1.5 w-4 rounded-full bg-[hsl(var(--green))]" />
          </span> {eyebrow}
        </div>
      </Reveal>
    )}
    <Reveal delay={0.05}><h2 className="heading-2">{title}</h2></Reveal>
    {lead && <Reveal delay={0.1}><p className="lead mt-4">{lead}</p></Reveal>}
    {children}
  </div>
);
